import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type TBadge = {
  label: string;
  icon: ReactNode;
  variant?: 'sm' | 'md';
  background?: 'bg-background' | 'bg-backgroundLight';
};

export const Badge: FC<TBadge> = ({ label, icon, variant = 'md', background = 'bg-background' }) => (
  <div className='group/badge'>
    <div
      className={twMerge(
        'flex flex-nowrap justify-between items-center gap-2 py-1.5 px-3 rounded-md text-foreground shadow-md',
        'border border-neutral-800/50 transition-all duration-200',
        'hover:border-action/40 hover:shadow-[0_4px_12px_rgba(251,192,11,0.1)]',
        background
      )}
    >
      <div
        className={twMerge(
          'transition-transform duration-200 group-hover/badge:scale-110',
          variant === 'sm' && 'min-w-3 md:min-w-4',
          variant === 'md' && 'min-w-4'
        )}
      >
        {icon}
      </div>
      <span
        className={twMerge(
          variant === 'sm' && 'text-xs md:text-base',
          variant === 'md' && 'text-base'
        )}
      >
        {label}
      </span>
    </div>
  </div>
);
